<template>
  <div class="card create-offers" :class="[(offerType == 'buy') ? 'seller' : 'buyer']">
    <div class="heading">
      <h2>Datos Generales</h2>
      <div class="subtype toggle">
        <span :class="{active : subtype=='open'}" @click="changeToOpen"> <vs-icon icon="done"></vs-icon><p class="oferta-p">Oferta</p>Abierta</span>
        <span data-test="select-offerdiriged" :class="{active : subtype=='direct'}" @click="changeToDirect"> <vs-icon icon="done"></vs-icon><p class="oferta-p">Oferta</p>Dirigida</span>
        <span v-if="this.currentUser.organization.isMuvinEnabled && offerType === 'sell'" data-test="select-offermuvin" :class="{active : subtype=='muvin'}" @click="changeToMuvin"><vs-icon icon="done"></vs-icon><p class="oferta-p">Oferta</p><img src="@/assets/images/muvin-logo.png" alt="Logo Muvin" class="mobile-muvin-image"></span>
      </div>
    </div>
    <div class="form-offer">
      <WeWeekPicker label="Semana de entrega"
                    ref="weekSelector"
                    v-validate="'required'"
                    :hasError="this.errors.has('week')"
                    :errorMsg="this.errors.first('week')"
                    v-model="week"
                    :min-week="minWeek"
                    data-vv-name="week"/>
      <vs-input name="quantity"
                data-test="input-numporc"
                v-model.number="quantity"
                v-validate="'required|numeric|min_value:1|max:6'"
                :danger="this.errors.has('quantity')"
                :danger-text="this.errors.first('quantity')"
                size="large"
                type="number"
                label-placeholder="Cantidad de animales"
                :disabled="subtype == 'muvin'">
      </vs-input>
      <div :class="subtype != 'muvin' ? 'input-group price-kms-grid small' : 'input-group small'">
        <vs-input name="price"
                  data-test="input-price"
                  @keydown.188="replaceForDot"
                  v-model.number="price"
                  v-validate="'required|decimal|min_value:1|maxPrice'"
                  :danger="this.errors.has('price')"
                  :danger-text="this.errors.first('price')"
                  size="large"
                  label-placeholder="Precio"
                  description-text="$/Kg sin IVA"
                  class="format-type grid-1"
                  :class="{active:price}">
        </vs-input>
        <div class="wrapper tip grid-2" v-if="showKilometers && subtype != 'muvin'">
          <vs-input name="kilometers"
                    @keydown.188="replaceForDot"
                    v-model.number="kilometers"
                    v-validate="'required|numeric|min_value:1|max_value:9999'"
                    :danger="this.errors.has('kilometers')"
                    :danger-text="this.errors.first('kilometers')"
                    size="large"
                    label-placeholder="Kms"
                    class="format-type"
                    :class="{active:kilometers}">
          </vs-input>
          <span class="infotip top">
            <button class="infotip__host" aria-controls="infotip-overlay" aria-expanded="true" aria-label="Help" type="button">
              <vs-icon icon="help_outline"/>
            </button>
            <span class="infotip__live-region" aria-live="off">
              <div class="infotip__overlay" id="infotip-overlay">
                <p>Kilómetros de distancia máxima que contempla el precio con entrega a destino</p>
              </div>
            </span>
          </span>
        </div>
      </div>
      <div class="input-group">
        <select name="selectCategoryList"
                data-test="select-category"
                v-validate="'required'"
                :danger="this.errors.has('selectCategoryList')"
                v-model="category"
                :class="{changed: !!(category)}">
          <option value="" disabled>Categoría</option>
          <option :key="index" :value="item" :text="item" v-for="(item,index) in selectCategoryList">{{ item | mei }}</option>
        </select>
        <label for="selectCategoryList">Categoría</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('selectCategoryList') }}</span>
        </div>
      </div>
      <div class="input-group">
        <select name="offerOriginId"
                data-test="select-offerOriginId"
                v-validate="'required'"
                :danger="this.errors.has('offerOriginId')"
                v-model="offerPrincipalActor"
                :class="{changed: !!(offerPrincipalActor)}">
          <option value="">Establecimiento {{ (offerType == 'buy') ? 'destino' : 'origen' }}</option>
          <option :key="index" :value="item.id" :text="item.name" v-for="(item,index) in (subtype != 'muvin' ? originList : originListMuvin)">{{ item.name }} ({{ item.city }}, {{ item.state }})</option>
        </select>
        <label for="offerOriginId">Establecimiento {{ (offerType == 'buy') ? 'destino' : 'origen' }}</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('offerOriginId') }}</span>
        </div>
      </div>
      <div v-if="subtype != 'muvin'">
        <div class="switch">
          <input data-test="input-deliveryAtDestination" class="we-toggle" type="checkbox" id="deliveryAtDestination" name="deliveryAtDestination" v-model="deliveryAtDestination"/>
          <label for="deliveryAtDestination">Entrega en destino</label>
        </div>
        <div v-if="(offerType === 'sell' && deliveryAtDestination) || (offerType == 'buy' && !deliveryAtDestination)" class="alert alert--small info no-icon">
          <span>El transporte incluido en el precio contempla {{ (offerType == 'sell') ? '' : 'el retiro de la mercadería en el establecimiento de origen ' }}hasta <strong>{{ kilometers ? kilometers : 0 }} kms</strong> desde el establecimiento {{ (offerType == 'sell') ? 'origen' : 'destino' }}.</span>
        </div>
      </div>
      <div class="input-group" v-if="subtype === 'direct'">
        <select name="offerDestinationId"
                data-test="select-offerDestinationId"
                v-validate="'required'"
                :danger="this.errors.has('offerDestinationId')"
                v-model="offerSecondActor"
                :class="{changed: !!(offerSecondActor)}">
          <option value="">Establecimiento {{ (offerType == 'sell') ? 'destino' : 'origen' }}</option>
          <option :key="index" :value="item.id" :text="item.name" v-for="(item,index) in destinationListSortedByOrganization">{{ item.organization.businessName }}, {{ item.name }} ({{ item.city }}, {{item.state}})</option>
        </select>
        <label for="offerDestinationId">Establecimiento {{ (offerType == 'sell') ? 'destino' : 'origen' }}</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('offerDestinationId') }}</span>
        </div>
      </div>
      <div class="input-group" v-if="subtype === 'muvin'">
        <select name="offerMuvinDestinationId"
                data-test="select-offerMuvinDestinationId"
                v-model="offerSecondActorMuvin"
                v-validate="'required'"
                :danger="this.errors.has('offerMuvinDestinationId')"
                :class="{changed: !!(offerSecondActorMuvin)}"
                @change="getDestinationListMuvin()">
          <option value="">Organización destino</option>
          <option :key="index" :value="item.id" :text="item.businessName" v-for="(item,index) in destinationOrganizationsMuvin">{{ item.businessName }} ({{ item.city }})</option>
        </select>
        <label for="offerMuvinDestinationId" v-if="subtype == 'muvin'">Organización destino</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('offerMuvinDestinationId') }}</span>
        </div>
      </div>
      <div class="input-group">
        <label for="publishedAt" class="date-picker-label">Fecha de publicación</label>
        <VueCtkDateTimePicker
          v-model="publishedAt"
          data-test="select-publishedAt"
          name="publishedAt"
          label="Fecha de publicación"
          no-label
          color="#01143C"
          v-validate="'required'"
          only-date
          no-button-now
          locale="es"
          no-shortcuts
          auto-close
          format="DD-MM-YYYY"
          :first-day-of-week="1"
          :min-date="minDateForPublishedAt"
          :max-date="maxDateForPublishedAt"
          :class="{error: this.errors.has('publishedAt')}"/>
        <span v-if="this.errors.has('publishedAt')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          {{ this.errors.first('publishedAt') }}
        </span>
      </div>
      <div class="input-group">
        <label for="dueAt" class="date-picker-label">Fecha de vigencia</label>
        <VueCtkDateTimePicker
          v-model="dueAt"
          data-test="select-publishedDueAt"
          name="dueAt"
          label="Fecha de vigencia"
          no-label
          color="#01143C"
          only-date
          no-button-now
          :noClearButton="this.subtype === 'muvin'"
          v-validate="'required'"
          locale="es"
          no-shortcuts
          auto-close
          format="DD-MM-YYYY"
          :first-day-of-week="1"
          :min-date="minDateForDueAt"
          :max-date="maxDateForDueAt"
          :class="{error: this.errors.has('dueAt')}"
          :disabled="subtype == 'muvin'"/>
        <span v-if="this.errors.has('dueAt')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          {{ this.errors.first('dueAt') }}
        </span>
      </div>
      <div v-if="subtype === 'open'" class="switch">
        <input data-test="input-hideIdentity" class="we-toggle" type="checkbox" id="hideIdentity" name="hideIdentity" v-model="hideIdentity"/>
        <label for="hideIdentity">Ocultar identidad</label>
      </div>
      <div class="wrapper tip" v-if="hideIdentity">
        <vs-input name="region"
                  v-model.number="region"
                  v-validate="'max:50'"
                  :danger="this.errors.has('region')"
                  :danger-text="this.errors.first('region')"
                  size="large"
                  label-placeholder="Determinar Región">
        </vs-input>
        <span class="infotip top">
          <button class="infotip__host" aria-controls="infotip-overlay" aria-expanded="true" aria-label="Help" type="button">
            <vs-icon icon="help_outline"/>
          </button>
          <span class="infotip__live-region" aria-live="off">
            <div class="infotip__overlay" id="infotip-overlay">
              <p>Al tener este campo vacío, se mostrará la ciudad y provincia a la que su entidad pertenece</p>
            </div>
          </span>
        </span>
      </div>
      <div class="input-group">
        <select name="conflictResolution"
                data-test="conflictResolution"
                v-validate="'required'"
                :danger="this.errors.has('conflictResolution')"
                v-model="conflictResolution"
                :class="{changed: !!(conflictResolution)}">
          <option value="" disabled>Resolución de confictos</option>
          <option v-for="(res, index) in conflictResolutionOptions" :key="index" >{{ res }}</option>
        </select>
        <label for="selectCategoryList">Resolución de confictos</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('conflictResolution') }}</span>
        </div>
      </div>
    </div>
    <div v-if="subtype != 'muvin'">
      <h2>Forma de pago</h2>
      <div class="form-offer">

        <div class="checkbox secure-payment-toggle">
          <div class="wrapper" ref="securePayCheck">
            <input type="checkbox" id="securePayment" class="we-check" v-model="securePayment">
            <label data-test="input-checkbox" for="securePayment">Utilizar pago seguro</label>
          </div>
          <div class="wrapper" ref="agroNacionPayment">
            <input type="checkbox" id="agroNacionPayment" class="we-check" v-model="agroNacionPayment">
            <label data-test="input-checkbox" for="agroNacionPayment">Botón AgroNación</label>
          </div>
        </div>

        <div v-show="securePayment" class="secure-payment-percentage">
          <vs-input name="securePaymentPercentage"
                  v-model.number="securePaymentPercentage"
                  v-validate="(securePayment) ? 'required|decimal|min_value:1|max_value:99' : ''"
                  :danger="this.errors.has('securePaymentPercentage')"
                  :danger-text="this.errors.first('securePaymentPercentage')"
                  size="large"
                  label-placeholder="Porcentaje de Pago Seguro"
                  description-text="%"
                  class="format-type"
                  :class="{active:securePaymentPercentage}">
          </vs-input>
        </div>
        <div v-show="securePayment" class="input-group secure-payment-date">
          <select name="securePaymentDateSelector"
                  v-validate="(securePayment) ? 'required' : ''"
                  :danger="this.errors.has('securePaymentDateSelector')"
                  v-model="securePaymentLapse"
                  :class="{changed: !!(securePaymentLapse)}">
            <option value="">Fecha de Transferencia de Pago Seguro</option>
            <option :key="index" :value="item" :text="item" v-for="(item,index) in securePaymentDateList">{{ item }} hs.</option>
          </select>
          <label for="securePaymentDateSelector">Fecha de Transferencia de Pago Seguro</label>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('securePaymentDateSelector') }}</span>
          </div>
        </div>
        <div v-if="negotiableAttributeSecurePay && securePayment" class="alert no-icon info">
          <p>
            Usted eligió Pago Seguro como atributo negociable, la forma y plazo de pago solicitados a continuación serán utilizados en caso de que se cierre una operación sin esta condición.
          </p>
        </div>
        <div v-if="agroNacionPayment" class="alert no-icon info">
          <p>
            Al seleccionar esta opción, se permite el pago AgroNación. Recuerde que para que se realice la transferencia bajo esta condición, el comprador y el vendedor tienen que estar adheridos al servicio.
          </p>
        </div>
        <div v-show="!securePayment || negotiableAttributeSecurePay" class="input-group">
          <select name="offerPaymentMethodList"
                  ref="pmSelector"
                  data-test="select-offerPaymentMethod"
                  v-validate="requiredPaymentMethodFields"
                  :danger="this.errors.has('offerPaymentMethodList')"
                  v-model="paymentMethod"
                  :class="{changed: !!(paymentMethod)}">
            <option value="" disabled>Forma de pago</option>
            <option :key="index" :value="item.replace(/\s/g, '')" :text="item" v-for="(item,index) in offerPaymentMethodList">{{ item }}</option>
          </select>
          <label for="offerPaymentMethodList">Forma de pago</label>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('offerPaymentMethodList') }}</span>
          </div>
        </div>

        <div v-show="!securePayment || negotiableAttributeSecurePay" class="input-group multiple">
          <div class="input" v-bind:class="{ 'input-icon-validate-danger': showValidationDays }">
            <vs-input name='daysTerm'
                      v-model="plazo"
                      v-validate="'numeric|min_value:0|max:3'"
                      :danger="this.errors.has('daysTerm')"
                      :danger-text="this.errors.first('daysTerm')"
                      @keyup.enter='pushDays'
                      size="large"
                      data-test="select-paymentDeadline"
                      label-placeholder="Plazo de pago">
            </vs-input>
            <span data-test="pushDays" @click="pushDays" class="button"><vs-icon icon="add"/></span>
            <div v-if="showValidationDays" id="alert-plazo-pago" class="con-text-validation span-text-validation-danger vs-input--text-validation-span"><span> Solo se admite una cantidad de hasta 5 plazos de pago.</span></div>
          </div>

          <div class="input">
            <vs-input name="paymentDays"
                      v-validate="requiredPaymentMethodFields"
                      :danger="this.errors.has('paymentDays')"
                      :danger-text="this.errors.first('paymentDays')"
                      disabled='disabled'
                      :value="pushPaymentsDays"
                      size="large"
                      label-placeholder="Dias">
            </vs-input>
            <span data-test="deleteDays" v-if="dayDeadline.length" @click='dayDeadline=[]; plazo=""; showValidationDays=false;' class="button"><vs-icon icon="delete"/></span>
          </div>
        </div>

      </div>
    </div>
      <h2>Calidad</h2>
      <div class="form-offer">
        <vs-input name="slaughterWeight"
                  data-test="input-slaughterWeight"
                  v-validate="'required|decimal|min_value:1|maxValue'"
                  @keydown.188="replaceForDot"
                  :danger="this.errors.has('slaughterWeight')"
                  :danger-text="this.errors.first('slaughterWeight')"
                  v-model="qualitySlaughterWeight"
                  size="large"
                  label-placeholder="Peso Faena"
                  description-text="(± 5) Kgs"
                  class="format-type"
                  :class="{active: qualitySlaughterWeight}">
        </vs-input>
        <div class="input-group pri" v-if="subtype != 'muvin'">
          <select name="qualityLeanQuality"
                  data-test="select-qualityLeanQuality"
                  :danger="this.errors.has('qualityLeanQuality')"
                  v-model="qualityLeanQuality"
                  :class="{changed: !!(qualityLeanQuality)}"
                  :label-placeholder="'Calidad magro'">
            <option value="">Calidad Magro (Opcional)</option>
            <option :key="index" :value="category" :text="category" v-for="(category,index) in leanQualityList">{{ category }}</option>
          </select>
          <label for="state">Calidad Magro (Opcional)</label>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
              <span> {{ this.errors.first('qualityLeanQuality') }}</span>
          </div>
        </div>
        <vs-input name="qualityPerformance"
                  data-test="input-qualityPerfomance"
                  v-validate="'decimal:2|min_value:0|max_value:100'"
                  @keydown.188="replaceForDot"
                  :danger="this.errors.has('qualityPerformance')"
                  :danger-text="this.errors.first('qualityPerformance')"
                  v-model="qualityPerformance"
                  size="large"
                  :label-placeholder="'Rendimiento (Opcional)'"
                  description-text="%"
                  class="format-type"
                  :class="{active:qualityPerformance}"
                  v-if="subtype != 'muvin'">
        </vs-input>
        <vs-input name="qualityDorsalFat"
                  data-test="input-qualityDorsalFat"
                  @keydown.188="replaceForDot"
                  v-validate="'decimal:2|min_value:0|max_value:50'"
                  :danger="this.errors.has('qualityDorsalFat')"
                  :danger-text="this.errors.first('qualityDorsalFat')"
                  v-model="qualityDorsalFat"
                  size="large"
                  :label-placeholder="'Grasa dorsal (Opcional)'"
                  description-text="mm"
                  class="format-type"
                  :class="{active:qualityDorsalFat}"
                  v-if="subtype != 'muvin'">
        </vs-input>
      </div>
    <div v-if="subtype != 'muvin'">
      <h2>Atributos negociables</h2>
      <h4>Generales</h4>
      <ul class="negotiable-attributes">
        <li>
          <input data-test="input-priceCheckBox" class="we-toggle" type="checkbox" id="negotiableAttributePrice" name="negotiableAttributePrice" v-model="negotiableAttributePrice"/>
          <label for="negotiableAttributePrice">Precio</label>
        </li>
        <li>
          <input data-test="input-quantityCheckBox" class="we-toggle" type="checkbox" id="negotiableAttributeQuantity" name="negotiableAttributeQuantity" v-model="negotiableAttributeQuantity"/>
          <label for="negotiableAttributeQuantity">Cantidad de animales</label>
        </li>
        <li>
          <input data-test="input-deliveryAtDestinationCheckBox" class="we-toggle" type="checkbox" id="negotiableAttributeDeliveryAtDestination" name="negotiableAttributeDeliveryAtDestination" v-model="negotiableAttributeDeliveryAtDestination"/>
          <label for="negotiableAttributeDeliveryAtDestination">Entrega en destino</label>
        </li>
        <li>
          <input data-test="input-qualityCheckBox" class="we-toggle" type="checkbox" id="negotiableAttributeQuality" name="negotiableAttributeQuality" v-model="negotiableAttributeQuality"/>
          <label for="negotiableAttributeQuality">Calidad</label>
        </li>
      </ul>

      <h4>Pago seguro <small class="info"><vs-icon icon="info"/> Siempre es negociable excepto que se permita pago AgroNación</small></h4>

      <ul class="negotiable-attributes">
        <li>
          <input class="we-toggle" v-model="negotiableAttributeSecurePay" type="checkbox" name="negotiableAttributeSecurePay" checked="true" disabled>
          <label for="negotiableAttributeSecurePay">Pago Seguro</label>
        </li>
        <li>
          <input class="we-toggle" v-model="negotiableAttributePercentage" type="checkbox" name="negotiableAttributePercentage" checked="true" disabled>
          <label for="negotiableAttributePercentage">Porcentaje de Pago Seguro</label>
        </li>
        <li>
          <input class="we-toggle" type="checkbox" v-model="negotiableAttributeLapse" name="negotiableAttributeLapse" checked="true" disabled>
          <label for="negotiableAttributeLapse">Fecha de Transferencia de Pago Seguro</label>
        </li>
      </ul>

      <h2>Observaciones</h2>
      <div class="input-group">
        <textarea data-test="input-description" name="description" placeholder="Observaciones (opcional)" v-model="description" :class="{changed: !!(description)}" rows="5"/>
        <label for="comments">Observaciones (opcional)</label>
      </div>
    </div>
    <div v-if="subtype === 'muvin'">
      <h2>Datos de la entrega <img src="@/assets/images/muvin-logo.png" class="mobile-muvin-dsl-image"></h2>
      <div class="form-offer-delivery-sch-lines" v-for="(deliveryScheduleLine, counter) in deliveryScheduleLines" v-bind:key="counter">
        <div class="input-group">
          <label :for="`deliveryDay-${counter}`" class="date-picker-label">Fecha de envío</label>
          <VueCtkDateTimePicker 
            v-model="deliveryScheduleLine.deliveryDay"
            data-test="select-deliveryScheduleLine-deliveryDay"
            :name="`deliveryDay-${counter}`"
            v-validate="'required'"
            :class="{error: errors.has(`deliveryDay-${counter}`)}"
            label="Fecha de envío"
            no-label
            color="#01143C"
            only-date
            no-button-now
            locale="es"
            no-shortcuts
            auto-close
            format="DD-MM-YYYY"
            :first-day-of-week="1"
            :min-date="minDateForDeliveryDay || currentDate"
            :max-date="maxDateForDeliveryDay"
            :disabled="week == ''"/>
          <span v-if="errors.has(`deliveryDay-${counter}`)" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            {{ errors.first(`deliveryDay-${counter}`) }}
          </span>
        </div>
        <vs-input :name="`dslQuantity-${counter}`"
                  data-test="input-numporc"
                  v-model="deliveryScheduleLine.quantity"
                  v-validate="'required|numeric|min_value:1'"
                  :danger="errors.has(`dslQuantity-${counter}`) || errors.has('deliveryDay-quantity-sum-error')"
                  :danger-text="errors.first(`dslQuantity-${counter}`) || errors.first('deliveryDay-quantity-sum-error')"
                  size="large"
                  type="number"
                  :max='quantity'
                  @change="sumTotalQuantity()"
                  label-placeholder="Cantidad">
        </vs-input>
        <div class="input-group" style="display: grid">
          <select :name="`dslEstablishmentId-${counter}`"
                  data-test="select-deliveryScheduleLines-establishmentId"
                  v-validate="'required'"
                  :danger="errors.has(`dslEstablishmentId-${counter}`)"
                  :danger-text="errors.first(`dslEstablishmentId-${counter}`)"
                  v-model="deliveryScheduleLine.establishmentId"
                  :class="{changed: !!(deliveryScheduleLine.establishmentId)}"
                  style="grid-column: 1/20">
              <option value="">Destino</option>
              <option :key="index" :value="item.id" :text="item.name" v-for="(item,index) in destinationListMuvin">{{ item.name }} ({{ item.city }}, {{ item.state }})</option>
          </select>
          <label for="dslEstablishmentId">Establecimiento destino</label>
          <span v-if="errors.has(`dslEstablishmentId-${counter}`)" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            {{ errors.first(`dslEstablishmentId-${counter}`) }}
          </span>
          <button class="secondary" @click="deleteDeliveryScheduleLine(counter)" style="grid-column: 20/20" v-if="deliveryScheduleLines.length > 1">
            <i class="vs-icon notranslate icon-scale material-icons null">delete</i>
            Borrar
          </button>
        </div>
      </div>
      <Transition name="fade" mode="in-out">
        <button type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled button-add-new-dsl" @click="addScheduleLine">
          Agregar nueva entrega
        </button>
      </Transition>
    </div>
    <div class="offer-buttons">
      <vs-button color="#e0e0e0" type="filled" @click="goBack">Volver</vs-button>
      <button data-test="button-createoffer" type="filled" @click="postOffer" class="btn btn--large success" :class="{'btn--loading': loading}">Crear oferta</button>
    </div>
    <div v-show="errorMsg" class="validation-error-message">
      <div v-for="(error, index) in errorMsg" :key="index">
        {{ $t(`offer.create.${error}`) }}
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import WeWeekPicker from '../lib/WebExperto/components/WeWeekPicker.vue'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapState, mapMutations } from 'vuex'
import { Validator } from 'vee-validate'

const SelectableAttributes = gql`
  query retrieveSelectableAttributes($object: String!, $attribute: String!) {
    retrieveSelectableAttributes(object: $object, attribute: $attribute) {
      code
      selectableAttributes
      message
      success
    }
  }
`
const createOffer = gql`
  mutation createOffer($conflictResolution: String!, $paymentMethod: String!, $offerType: String!, $offerCategory: String!, $subtype: String!, $week: String!, $quantity: Int!, $publishedAt: String!, $dueAt: String!, $paymentDeadline: String!, $offerParts: PartAttributes!, $offerQuality: QualityInput!, $offerNegotiableAttributes: NegotiableAttributesInput!, $price: Float!, $hideIdentity: Boolean, $deliveryAtDestination: Boolean!, $currentUserToken: String!, $description: String, $securePayment: CreateSecurePayment, $kilometers: Int, $region: String, $agroNacionPayment: Boolean!, $deliveryScheduleLines: [DeliveryScheduleLineInput!]) {
    createOffer(conflictResolution: $conflictResolution , paymentMethod: $paymentMethod, offerType: $offerType, offerCategory: $offerCategory, subtype: $subtype, week: $week, quantity: $quantity, publishedAt: $publishedAt, dueAt: $dueAt, paymentDeadline: $paymentDeadline, offerParts: $offerParts, offerQuality: $offerQuality, offerNegotiableAttributes: $offerNegotiableAttributes, price: $price, hideIdentity: $hideIdentity, deliveryAtDestination: $deliveryAtDestination, currentUserToken: $currentUserToken, description: $description, securePayment: $securePayment, kilometers: $kilometers, region: $region, agroNacionPayment: $agroNacionPayment, offerDeliveryScheduleLines: $deliveryScheduleLines) {
      success
      code
      codes
      message
    }
  }
`
const administrableEstablishments = gql`
  query administrableEstablishments($currentUserToken: String!, $type: String) {
    administrableEstablishments(currentUserToken: $currentUserToken, type: $type) {
      id
      name
      number
      city
      state
      marketRole
      active
    }
  }
`

const administrableEstablishmentsMuvin = gql`
  query administrableEstablishmentsMuvin($currentUserToken: String!, $type: String) {
    administrableEstablishments(currentUserToken: $currentUserToken, type: $type, muvin: true) {
      id
      name
      number
      city
      state
      marketRole
      active
    }
  }
`

const listEstablishments = gql`
  query listEstablishments($type: String, $currentUserToken: String) {
    listEstablishments(type: $type, currentUserToken: $currentUserToken) {
      id
      name
      number
      city
      state
      marketRole
      organization {
        businessName
      }
    }
  }
`
const listEstablishmentsMuvin = gql`
  query listEstablishmentsMuvin($type: String, $currentUserToken: String, $organizationId: Int) {
    listEstablishmentsMuvin(type: $type, currentUserToken: $currentUserToken, organizationId: $organizationId) {
      id
      name
      number
      city
      state
      marketRole
      organization {
        businessName
      }
    }
  }
`

const listOrganizationsMuvin = gql`
  query listOrganizationsMuvin($currentUserToken: String!, $getOnlyMuvin: Boolean) {
    listOrganizations(currentUserToken: $currentUserToken, getOnlyMuvin: $getOnlyMuvin) {
      organizations{
        id
        businessName
        city
        establishments{
          id
        }
      }
    }
  }
`

const offerData = gql`
  query offerDetailToClone($currentUserToken: String!, $offerId: Int!) {
    offerDetailToClone(currentUserToken: $currentUserToken, offerId: $offerId) {
        conflictResolution
        offerType
        category{
          name
        }
        subtype
        week
        quantity
        publishedAt
        dueAt
        part{
            opener{
              id
            }
            origin{
              id
            }
            destination{
              id
            }
          	destinationOrganization{
              id
            }
        }
        quality{
            qualitySegment
            performance
            leanQuality
            dorsalFat
            slaughterWeight
        }
        deliveryScheduleLines{
            deliveryDay
            quantity
            establishment{
              id
            }
          finalQuantity
        }
        negotiableAttributes{
        		deliveryAtDestination
          	dorsalFat
          	leanQuality
          	performance
          	price
          	quantity
          	securePayment{
              lapse
              lock
              percentage
            }
          	slaughterWeight
        }
        securePayment{
          	id
            lapse
            observations
            percentage
          	stage
        }
        price
        kilometers
        hideIdentity
        deliveryAtDestination
        description
        agroNacionPayment
        paymentMethod
        paymentDeadline
        region
    }
}
`

export default {
  name: 'clone-offer-form',
  components: {
    VueCtkDateTimePicker,
    WeWeekPicker
  },
  props: {
    // TODO: Add validation in props offerType to be 'sell' or 'buy'
    offerType: {
      type: String,
      required: false,
      default: 'buy'
    },
    offerCloneId: {
      type: String,
    }
  },
  data () {
    return {
      securePayment: false,
      securePaymentPercentage: '',
      securePaymentLapse: '',
      securePaymentDateList: [],
      negotiableAttributeSecurePayment: false,
      negotiableAttributeSecurePaymentDate: true,
      negotiableAttributeSecurePaymentPercentage: true,
      dayDeadline:[],
      leanQualityList: [],
      selectCategoryList: [],
      plazo: '',
      offerCategoryList: [],
      offerPaymentMethodList: [],
      originList: [],
      originListMuvin: [],
      destinationList: [],
      destinationListMuvin: [],
      destinationOrganizationsMuvin: [],
      errorMsg: [],
      offerPrincipalActor: '',
      offerSecondActor: '',
      offerSecondActorMuvin: '',
      conflictResolutionOptions: [],
      loading: false,
      agroNacionPayment: false,
      currentTime: (new Date).toLocaleString(),
      description: '',
      showValidationDays: false,
      deliveryScheduleLines: [],
      //offerCloneData: {}
    }
  },
  watch: {
    currentUser (newValue, oldValue) {
      this.getOriginList()
      this.getDestinationList()
      this.currentTime = this.currentUser.currentTime
    },
    publishedAt () {
      if (this.publishedAt && this.dueAt) {
        this.checkDueAt()
      }
    },
    week () {
      if (this.week) {
        var date = new Date(this.actualTime)
        date.setHours(0,0,0,0)
        var dueDate = (this.week == this.minWeek) ? this.getMaxDate(8) : this.getMaxDate()
        if (this.dueAt) {
          var daDate = new Date(this.dueAt.split('-')[2], this.dueAt.split('-')[1] - 1, this.dueAt.split('-')[0])
          if (daDate > dueDate) {
            this.dueAt = ''
          }
        }
        if (this.publishedAt) {
          var paDate = new Date(this.publishedAt.split('-')[2], this.publishedAt.split('-')[1], this.publishedAt.split('-')[0])
          if (paDate > dueDate && this.subtype != 'muvin') { this.publishedAt = '' }
        }
        if (dueDate >= date) {
          this.dueAt = `${dueDate.getDate()}-${dueDate.getMonth() + 1}-${dueDate.getFullYear()}`
        }
        if (this.deliveryScheduleLines && this.deliveryScheduleLines.length > 0){
          this.deliveryScheduleLines.forEach(function(dsl) {
            dsl.deliveryDay = ""
          })
        }
      }
    },
    negotiableAttributeSecurePay () {
      //if (!this.securePayment) {
      //  this.negotiableAttributePercentage = !!this.negotiableAttributeSecurePay
      //  this.negotiableAttributeLapse = !!this.negotiableAttributeSecurePay
      //}
    },
    agroNacionPayment() {
      this.securePayment = this.agroNacionPayment? false : this.securePayment;
      this.negotiableAttributeSecurePay = !this.agroNacionPayment
      this.negotiableAttributePercentage = !this.agroNacionPayment
      this.negotiableAttributeLapse = !this.agroNacionPayment
    },
    securePayment(){
      this.agroNacionPayment = this.securePayment? false : this.agroNacionPayment;
    },
    paymentMethod (newValue, oldValue){
      //this.dayDeadline = []
      //if(newValue.toLocaleLowerCase() == 'transferencia') {
        //this.plazo = 0
        //this.pushDays()
      //}
    }

  },
  beforeMount(){
    if (this.currentUser) {
      this.getOriginList()
      this.getOriginListMuvin()
      this.getDestinationList()
      this.getDestinationListMuvin()
      this.getOrganizationListMuvin()
      this.currentTime = this.currentUser.currentTime
    }
    this.resetState()
    this.getAttributeList("marketplace/offer", "conflict_resolution", "conflictResolutionOptions")
    this.getAttributeList("marketplace/quality", "lean_quality", "leanQualityList")
    this.getAttributeList("marketplace/offer", "categories", "selectCategoryList")
    this.getAttributeList("marketplace/offer", "payment_methods", "offerPaymentMethodList")
    this.getAttributeList("marketplace/secure_payment", "lapse", 'securePaymentDateList')
  },
  mounted () {
    this.negotiableAttributeSecurePay = true
    this.negotiableAttributePercentage = true
    this.negotiableAttributeLapse = true
    this.getOfferData()
  },
  methods: {
    getOfferData () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(offerData),
        variables: {
          offerId: parseInt(this.$route.params.offerId),
          currentUserToken: localStorage.getItem('USER_TOKEN'),
        }
      }}).then(res => {
        if (!res.data.errors) {
          let offerCloneData = res.data.data.offerDetailToClone
          this.subtype = offerCloneData.subtype
          this.quantity = offerCloneData.quantity
          this.price = offerCloneData.price
          this.category = offerCloneData.category.name
          if (this.offerType === 'sell'){
            this.offerPrincipalActor = offerCloneData.part.origin != null ? offerCloneData.part.origin.id : ''
            this.offerSecondActor = offerCloneData.part.destination != null ? offerCloneData.part.destination.id : ''
            //MUVIN
            this.offerSecondActorMuvin = offerCloneData.part.destinationOrganization != null ? offerCloneData.part.destinationOrganization.id : ''
            this.deliveryScheduleLines = []
            for (var i = 0; i < offerCloneData.deliveryScheduleLines.length; i++){
              this.deliveryScheduleLines.push({'deliveryDay': '', 'quantity': offerCloneData.deliveryScheduleLines[i].quantity, 'establishmentId': offerCloneData.deliveryScheduleLines[i].establishment.id})
            }
          }
          else{
            this.offerPrincipalActor = offerCloneData.part.destination != null ? offerCloneData.part.destination.id : ''
            this.offerSecondActor = offerCloneData.part.origin != null ? offerCloneData.part.origin.id : ''
          }
          this.conflictResolution = offerCloneData.conflictResolution
          this.qualitySlaughterWeight = offerCloneData.quality.slaughterWeight != null ? offerCloneData.quality.slaughterWeight : ''
          if (this.subtype != 'muvin'){
            this.kilometers = offerCloneData.kilometers
            this.deliveryAtDestination = offerCloneData.deliveryAtDestination
            this.hideIdentity = offerCloneData.hideIdentity != null ? offerCloneData.hideIdentity : false
            this.securePayment = offerCloneData.securePayment != null ? offerCloneData.securePayment : false
            if (this.securePayment){
              this.securePaymentPercentage = offerCloneData.securePayment.percentage
              this.securePaymentLapse = offerCloneData.securePayment.lapse
            }
            this.paymentMethod = offerCloneData.paymentMethod
            this.agroNacionPayment = offerCloneData.agroNacionPayment
            this.plazo = offerCloneData.paymentDeadline.replace(/\D/g, "").toString()
            this.pushDays()
            this.qualityLeanQuality = offerCloneData.quality != null ? offerCloneData.quality.leanQuality : ''
            this.qualityPerformance = offerCloneData.quality != null ? offerCloneData.quality.performance : ''
            this.qualityDorsalFat = offerCloneData.quality != null ? offerCloneData.quality.dorsalFat : ''
            this.negotiableAttributePrice = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.price : null
            this.negotiableAttributeQuantity = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.quantity : null
            this.negotiableAttributeDeliveryAtDestination = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.deliveryAtDestination : null
            this.negotiableAttributeQuality = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.quality : null
            this.negotiableAttributeSecurePaymentDate = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.securePayment.lapse : null
            this.negotiableAttributeSecurePaymentPercentage = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.securePayment.percentage : null
            this.negotiableAttributeSecurePayment = offerCloneData.negotiableAttributes != null ? offerCloneData.negotiableAttributes.securePayment.lock : null
            this.description = offerCloneData.description
            this.region = offerCloneData.region
          }
        }
        else{
          let display_error_message
          let error_messages = ["La oferta no existe o no le pertenece", "No puede clonar ofertas de venta", "No puede clonar ofertas de compra"]
          display_error_message = error_messages.includes(res.data.errors[0].message)
          console.log(display_error_message)
          this.$vs.notify({
            title: "Error al clonar la oferta",
            time: 5000,
            text: display_error_message ? res.data.errors[0].message : 'Hubo un error inesperado',
            color: "#eb4d4b",
            position: "top-center",
            icon: "error",
          });
          this.$router.push("/offers");
        }
      })
    },
    sumTotalQuantity(){
      if (this.deliveryScheduleLines.length == 1){
        this.quantity = this.deliveryScheduleLines[0].quantity.toString()
      }
      else{
        var sum = 0
        this.deliveryScheduleLines.forEach(function(dsl) {
          sum = sum + parseInt(dsl.quantity)
        })
        this.quantity = sum.toString()
      }
    },
    getAttributeList (objVariable, attrVariable, toArray){
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(SelectableAttributes),
        variables: {
          object: objVariable,
          attribute: attrVariable
        }
      }}).then( res => {
        if (!res.data.errors) {
          if (res.data.data.retrieveSelectableAttributes.success) {
            this[toArray] = res.data.data.retrieveSelectableAttributes.selectableAttributes
          }
        }
      })
    },
    pushDays (){
      if(this.paymentMethod.toLocaleLowerCase() == 'transferencia'){
        this.dayDeadline = []
      }
      if((this.dayDeadline.length + 1) <= 5 ){
        if (this.plazo !== '' && !this.errors.has('daysTerm')) {
          if (!this.dayDeadline.includes(this.plazo)) {
            this.dayDeadline.push(this.plazo)
          }
          this.plazo=''
          this.dayDeadline.sort((a,b) => {return a - b})
        }
      }else{
          this.plazo=''
          this.showValidationDays = true
      }
    },
    replaceForDot() {
      event.preventDefault()
      event.target.value = event.target.value + '.'
    },
    getMaxDate (plusDays = 0) {
      if (this.week) {
        var weekN = this.week.split('-')[0]
        var dueDate = this.getDateOfWeek(weekN, this.week.split('-')[1])
        //diff = dueDate.getDate() - dueDate.getDay() + (dueDate.getDay() == 0 ? -6:1); // adjust when day is sunday
        dueDate.setDate(dueDate.getDate() - dueDate.getDay() - 2 + parseInt(plusDays))
        return dueDate
      }
    },
    getMinDateDeliveryMuvin () {
      if (this.week) {
        var weekN = this.week.split('-')[0]
        var dateOfWeek = this.getDateOfWeek(weekN, this.week.split('-')[1])
        var minDate = new Date(dateOfWeek.setDate(dateOfWeek.getDate()-1));
        var today = new Date();
        today.setHours(0,0,0,0);  
        if (minDate < today){
          minDate = today
        }
        return minDate
      }
    },
    getDateOfWeek(week, year) {
      let day = new Date(year, 0, 1 + (week - 1) * 7);
      let dayOfWeek = day.getDay();
      let weekStart = day;
      if (dayOfWeek <= 7){
        weekStart.setDate(day.getDate() - day.getDay() + 1);
      } else{
        weekStart.setDate(day.getDate() + 8 - day.getDay());
      }
      return weekStart;
    },
    getMinWeek (date) {
      var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      d.setUTCDate(d.getUTCDate() + 7 - (d.getUTCDay()));
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
      return `${weekNo}-${d.getFullYear()}`;
    },
    checkDueAt () {
      const pbSplit = this.publishedAt.split('-')
      const pbDate = new Date(pbSplit[2], pbSplit[1], pbSplit[0])
      const dueSplit = this.dueAt.split('-')
      const dueDate = new Date(dueSplit[2], dueSplit[1], dueSplit[0])
      if (dueDate < pbDate) { this.dueAt = '' }
    },
    postOffer () {
      this.$validator.validate().then(res => {
        if (res) {
          this.loading = true
          this.createOffer()
        }
      })
    },
    changeToOpen () {
      this.subtype = 'open'
      this.$validator.reset()
    },
    changeToDirect () {
      this.subtype = 'direct'
      this.$validator.reset()
    },
    changeToMuvin () {
      this.subtype = 'muvin'
      this.$validator.reset()
      if (this.deliveryScheduleLines.length == 0){
        this.deliveryScheduleLines[0] = {
          deliveryDay: '',
          quantity: '',
          establishmentId: ''
        }
      }
      let break_principal_loop = false
      let offerSecondActor = this.offerSecondActor
      let offerSecondActorMuvin = this.offerSecondActorMuvin
      this.destinationOrganizationsMuvin.forEach(function(org) {
        org.establishments.forEach(function(est){
          if (est.id == offerSecondActor){
            break_principal_loop = true
            offerSecondActorMuvin = org.id;
            return
          }
        })
        if (break_principal_loop){
          return
        }
      })
      this.offerSecondActorMuvin = offerSecondActorMuvin
    },
    subtypeAttachFields () {
      switch (this.subtype) {
        case 'open':
          return {
            hideIdentity: this.hideIdentity,
            offerParts: { senderId: this.offerPrincipalActor, openerId: this.currentUser.id }
          }
        case 'direct':
          return {
            offerParts: { senderId: this.offerPrincipalActor, receiverId: this.offerSecondActor, openerId: this.currentUser.id }
          }
        case 'muvin':
          return {
            offerParts: { senderId: this.offerPrincipalActor, receiverId: this.deliveryScheduleLines[0].establishmentId, organizationReceiverId: this.offerSecondActorMuvin, openerId: this.currentUser.id }
          }
        default:
          return {}
      }
    },
    getOriginList () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(administrableEstablishments),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          type: (this.offerType == 'sell') ? 'seller' : 'buyer'
        }
      }}).then(res => {
        if (!res.data.errors) {

        //Sort establishments alphabetically by name before assigning it to originList

          this.originList = res.data.data.administrableEstablishments.filter(est => est.active).sort((a,b) =>  a.name.localeCompare(b.name))
          if (this.originList.length === 1) { this.offerPrincipalActor = this.originList[0].id }
          
        }
      })
    },
    getOriginListMuvin () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(administrableEstablishmentsMuvin),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          type: 'seller'
        }
      }}).then(res => {
        if (!res.data.errors) {
          //Sort establishments alphabetically by name before assigning it to destinationList
          this.originListMuvin = res.data.data.administrableEstablishments.sort((a,b) =>  a.name.localeCompare(b.name))
          if (this.originListMuvin.length === 1) { this.offerPrincipalActor = this.originListMuvin[0].id }
        }
      })
    },
    getDestinationList () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(listEstablishments),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          type: (this.offerType == 'sell') ? 'buyer' : 'seller'
        }
      }}).then(res => {
        if (!res.data.errors) {
          //Sort establishments alphabetically by name before assigning it to destinationList
          this.destinationList = res.data.data.listEstablishments.sort((a,b) =>  a.name.localeCompare(b.name))
        }
      })
    },
    getDestinationListMuvin () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(listEstablishmentsMuvin),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          type: 'buyer',
          organizationId: this.offerSecondActorMuvin ? parseInt(this.offerSecondActorMuvin) : null
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.destinationListMuvin = res.data.data.listEstablishmentsMuvin.sort((a,b) =>  a.name.localeCompare(b.name))
        }
      })
    },
    getOrganizationListMuvin () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(listOrganizationsMuvin),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          getOnlyMuvin: true
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.destinationOrganizationsMuvin = res.data.data.listOrganizations.organizations.sort((a,b) =>  a.businessName.localeCompare(b.businessName))
          if (this.destinationOrganizationsMuvin.length === 1) { this.offerSecondActorMuvin = this.destinationOrganizationsMuvin[0].id }
        }
      })
    },
    ...mapMutations('Offer', [
      'resetState'
    ]),
    createOffer () {
      if (this.subtype === 'muvin'){
        this.deliveryScheduleLines.forEach(function(dsl) {
          dsl.quantity = parseInt(dsl.quantity)
        });
      }
      let createOfferVariables = Object.assign({
        offerType: this.offerType,
        offerCategory: this.category,
        subtype: this.subtype,
        week: this.weekPost,
        quantity: parseInt(this.quantity),
        publishedAt: this.publishedAt,
        dueAt: this.dueAt,
        paymentMethod: this.subtype != 'muvin' ? this.paymentMethod : "",
        paymentDeadline: this.subtype != 'muvin' ? this.pushPaymentsDays : "",
        offerQuality: this.offer.offerQuality,
        offerNegotiableAttributes: this.offer.offerNegotiableAttributes,
        price: parseFloat(this.price),
        kilometers: this.showKilometers ? parseInt(this.kilometers) : null,
        region: this.subtype != 'muvin' ? String(this.region) : "",
        deliveryAtDestination: this.subtype != 'muvin' ? this.deliveryAtDestination : true,
        conflictResolution: this.conflictResolution,
        description: this.subtype != 'muvin' ? this.description : "",
        agroNacionPayment: this.subtype != 'muvin' ? this.agroNacionPayment : false,
        currentUserToken: localStorage.getItem('USER_TOKEN'),
        deliveryScheduleLines: this.subtype === 'muvin' ? this.deliveryScheduleLines : []
      }, this.subtypeAttachFields())
      if (this.securePayment && this.subtype != 'muvin') {
        Object.assign(createOfferVariables, {
          securePayment: {
            lapse: Number(this.securePaymentLapse),
            percentage: Number(this.securePaymentPercentage)
          }
        })
      }

      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(createOffer),
        variables: createOfferVariables
      }).then(res => {
        if (!res.data.errors) {
          if (res.data.data.createOffer.success) {
            //  this.negotiableAttributes
            this.$vs.notify({
              title: 'Oferta creada',
              time: 8000,
              text: 'Su oferta ha sido creada',
              color: '#50b83d',
              position: 'top-right',
              icon: 'check_circle'
            })
            this.$validator.reset()
            this.resetState()
            this.$router.push('/offers')
          } else {
            if (res.data.data.createUser.code == "unauthorized") {
              this.$vs.notify({
                title: 'No tiene permisos para realizar esta acción',
                time: 3000,
                //text: 'Por favor intente nuevamente',
                color: '#DE3618',
                position: 'top-right',
                icon: 'error'
              })
            } else {
              this.errorMsg = res.data.data.createOffer.codes
            }
          }
        } else {
          this.$vs.notify({
            title: 'Ha ocurrido un error',
            time: 6000,
            text: res.data.errors[0].message === 'No puede crear entregas para la misma fecha de envío y mismo establecimiento destino' ? res.data.errors[0].message : 'Por favor, intente crear la oferta nuevamente',
            color: '#DE3618',
            position: 'top-right',
            icon: 'error'
          })
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    goBack () {
      this.$router.go(-1);
    },
    addScheduleLine (){
      this.deliveryScheduleLines.push({
        deliveryDay: '',
        quantity: '',
        establishmentId: ''
      })
    },
    deleteDeliveryScheduleLine(counter){
      this.deliveryScheduleLines.splice(counter,1);
      this.sumTotalQuantity()
    },
    getCurrentDate () {
      const date = this.currentTime ? this.currentTime : (new Date).toLocaleString()
      if (/\//.test(date)) {
        return date.split(' ')[0].replace(/\//g, '-').split('-').reverse().join('-')
      }
      return date.split(' ')[0]
    },
  },
  computed: {
    ...mapState({
      offer: state => state.Offer.offer,
      currentUser: state => state.User.currentUser
    }),
    destinationListSortedByOrganization(){
        return this.destinationList.sort((a,b) =>  a.organization.businessName.localeCompare(b.organization.businessName));
    },
    requiredPaymentMethodFields () {
      if (!this.securePayment || this.negotiableAttributeSecurePay) {
        return 'required|'
      }
    },
    showKilometers () {
      if (this.offerType == 'buy' && !this.deliveryAtDestination) { return true }
      if (this.offerType == 'sell' && this.deliveryAtDestination) { return true }

      return false
    },
    minWeek () {
      const dateSplit = this.actualTime.split(' ')[0].replace(/\//g, '-').split('-')
      var date = new Date (parseInt(dateSplit[0]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[2]))
      return this.getMinWeek(date)
      // The min week can't be the actual, cause dueAt should be greater than today and less than week.
    },
    minDateForDueAt () {
      var date = new Date
      if (!!this.publishedAt) {
        const splitDate = this.publishedAt.split('-')
        date = new Date(splitDate[2], splitDate[1] - 1, splitDate[0])
      }
      return date.toJSON().split('T')[0]
    },
    currentDate () {
      return this.getCurrentDate()
    },
    actualTime () {
      return this.currentTime ? this.currentTime : (new Date).toLocaleString()
    },
    maxDateForPublishedAt () {
      if (this.week) {
        var maxDate = this.getMaxDate(2)
        return maxDate.toJSON().split('T')[0]
      }
      if (this.dueAt) {
        const splitDate = this.dueAt.split('-')
        var date = new Date(splitDate[2], splitDate[1] - 1, splitDate[0])
        return date.toJSON().split('T')[0]
      }
    },
    maxDateForDueAt () {
      if (this.week) {
        var maxDate = this.getMaxDate(2)
        var maxDateSplit = maxDate.toJSON().split('T')[0]
        if (this.subtype === 'muvin'){
          var maxDateSplitx2 = maxDateSplit.split('-')
          this.dueAt = `${maxDateSplitx2[2]}-${maxDateSplitx2[1]}-${maxDateSplitx2[0]}`
        }
        else{
          this.dueAt = ''
        }
        return maxDateSplit
      }
    },
    minDateForDeliveryDay () {
      if (this.week) {
        var minDate = this.getMaxDate(-4);
        const newMinDate = `${minDate.getFullYear()}-${minDate.getMonth() + 1}-${minDate.getDate()}`;
        return newMinDate;
      }
    },
    maxDateForDeliveryDay () {
      if (this.week) {
        var maxDate = this.getMaxDate(2)
        return maxDate.toJSON().split('T')[0]
      }
      if (this.dueAt) {
        const splitDate = this.dueAt.split('-')
        var date = new Date(splitDate[2], splitDate[1] - 1, splitDate[0])
        return date.toJSON().split('T')[0]
      }
    },
    minDateForPublishedAt(){
      var currentDate = this.getCurrentDate()
      if (this.subtype === 'muvin'){
        var currentDateSplit = currentDate.split('-')
      }
      return currentDate
    },
    type: {
      get () {
        return this.offer.offerType
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'offerType', data: 'offer', value: val })
      }
    },
    conflictResolution: {
      get () {
        return this.offer.conflictResolution
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'conflictResolution', data: 'offer', value: val })
      }
    },
    qualityDorsalFat: {
      get () {
        return this.offer.offerQuality.dorsalFat
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'dorsalFat', data: 'offer', object: 'offerQuality', value: val })
      }
    },
    qualityPerformance: {
      get () {
        return this.offer.offerQuality.performance
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'performance', data: 'offer', object: 'offerQuality', value: val })
      }
    },
    qualityLeanQuality: {
      get () {
        return this.offer.offerQuality.leanQuality
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'leanQuality', data: 'offer', object: 'offerQuality', value: val })
      }
    },
    qualitySlaughterWeight: {
      get () {
        return this.offer.offerQuality.slaughterWeight
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'slaughterWeight', data: 'offer', object: 'offerQuality', value: val })
      }
    },
    category: {
      get () {
        return this.offer.offerCategory
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'offerCategory', data: 'offer', value: val })
      }
    },
    subtype: {
      get () {
        return this.offer.subtype
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'subtype', data: 'offer', value: val })
      }
    },
    week: {
      get () {
        return this.offer.week
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'week', data: 'offer', value: val })
      }
    },
    price: {
      get () {
        return this.offer.price
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'price', data: 'offer', value: val })
      }
    },
    kilometers: {
      get () {
        return this.offer.kilometers
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'kilometers', data: 'offer', value: val })
      }
    },
    region: {
      get () {
        return this.offer.region
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'region', data: 'offer', value: val })
      }
    },
    quantity: {
      get () {
        return this.offer.quantity
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'quantity', data: 'offer', value: val })
      }
    },
    publishedAt: {
      get () {
        return this.offer.publishedAt
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'publishedAt', data: 'offer', value: val })
      }
    },
    dueAt: {
      get () {
        return this.offer.dueAt
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'dueAt', data: 'offer', value: val })
      }
    },
    paymentMethod: {
      get () {
        return this.offer.paymentMethod
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'paymentMethod', data: 'offer', value: val })
      }
    },
    hideIdentity: {
      get () {
        return this.offer.hideIdentity
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'hideIdentity', data: 'offer', value: val })
      }
    },
    deliveryAtDestination: {
      get () {
        return this.offer.deliveryAtDestination
      },
      set (val) {
        this.$store.commit('Offer/updateProperty', { prop: 'deliveryAtDestination', data: 'offer', value: val })
      }
    },
    negotiableAttributeQuality: {
      get () {
        return this.offer.offerNegotiableAttributes.quality
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'quality', data: 'offer', object: 'offerNegotiableAttributes', value: val })
      }
    },
    negotiableAttributeQuantity: {
      get () {
        return this.offer.offerNegotiableAttributes.quantity
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'quantity', data: 'offer', object: 'offerNegotiableAttributes', value: val })
      }
    },
    negotiableAttributePrice: {
      get () {
        return this.offer.offerNegotiableAttributes.price
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'price', data: 'offer', object: 'offerNegotiableAttributes', value: val })
      }
    },
    negotiableAttributeDeliveryAtDestination: {
      get () {
        return this.offer.offerNegotiableAttributes.deliveryAtDestination
      },
      set (val) {
        this.$store.commit('Offer/updateObjectProperty', { prop: 'deliveryAtDestination', data: 'offer', object: 'offerNegotiableAttributes', value: val })
      }
    },
    negotiableAttributeSecurePay: {
      get () {
        return this.offer.offerNegotiableAttributes.securePayment.lock
      },
      set (val) {
        this.$store.commit('Offer/updateSecurePaymentNegotiables', { prop: 'lock', value: val })
      }
    },
    negotiableAttributePercentage: {
      get () {
        return this.offer.offerNegotiableAttributes.securePayment.percentage
      },
      set (val) {
        this.$store.commit('Offer/updateSecurePaymentNegotiables', { prop: 'percentage', value: val })
      }
    },
    negotiableAttributeLapse: {
      get () {
        return this.offer.offerNegotiableAttributes.securePayment.lapse
      },
      set (val) {
        this.$store.commit('Offer/updateSecurePaymentNegotiables', { prop: 'lapse', value: val })
      }
    },
    pushPaymentsDays () {
      return this.dayDeadline.join()
    },
    weekPost () {
      const WY = this.week.split('-')
      return `${WY[1]}${WY[0]}`
    }
  },
}
</script>
<style scoped>

  .grid-1 {
    grid-column: 1/5;

  }
  .grid-2 {
    grid-column: 5/8;
  }

  .price-kms-grid {
    grid-template-columns: repeat(6, 1fr) !important;
    column-gap: 15px;
  }
</style>